import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { INVENTORY_CHECKLIST } from "./type";

export const getInventory = (url) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.inventoryCheckList}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: INVENTORY_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const postGateInventory = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.gateInventory}`
  );
  if (res?.data?.response?.status) {
    return true;
  } else return false;
};
